const { isEmptyOrNotSet, asArray, findByAddress } = require('@hints/utils/data');
const { isNull } = require('@hints/utils/types');
const hash = require('object-hash');

function mergeTravellers(maintravellers, travellers) {
    if (isEmptyOrNotSet(maintravellers)) return [];
    if (isEmptyOrNotSet(travellers)) travellers = [];
    maintravellers = asArray(maintravellers).map(t => ({ ...t, hash: _generateHash(t) }));
    travellers = asArray(travellers).map(t => ({ ...t, hash: _generateHash(t) }));
    return maintravellers.map(mainTraveller => {
        const matchingInRequest = travellers.find(t => ([mainTraveller.id, `T${mainTraveller.ref}`, `T${mainTraveller.reference}`].includes(t.id)) || mainTraveller.hash === t.hash);
        if (isEmptyOrNotSet(matchingInRequest)) return mainTraveller;
        Object.keys(mainTraveller).forEach(key => {
            if (isNull(mainTraveller[key])) delete mainTraveller[key];
        });
        if (isEmptyOrNotSet(mainTraveller.reference)) mainTraveller.reference = matchingInRequest.id;
        return { ...matchingInRequest, ...mainTraveller };
    });
}

module.exports = { mergeTravellers };

function _generateHash(traveller) {
    return hash({ firstName: findByAddress(traveller, 'firstName', '').toLowerCase(), lastName: findByAddress(traveller, 'lastName', '').toLowerCase(), birthDate: findByAddress(traveller, 'birthDate') });
}